export default {
  getLocalesCacheTimeoutInMs: 10 * 60 * 1000 // 10 minutes
};
